import { render, staticRenderFns } from "./NumberZone.vue?vue&type=template&id=4edd7a4e&"
import script from "./NumberZone.vue?vue&type=script&lang=ts&"
export * from "./NumberZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports